import React from "react";
import "../App.css";
import "font-awesome/css/font-awesome.min.css";
import Services from "../Components/Home/Services";
import Masthead from "../Components/Home/Masthead";

function Home() {
  return (
    <div>

      <Masthead />
      
      <Services />
      
    </div>
  );
}

export default Home;
